import React from "react";
import "./Transfer.css";
import image from "../../../assets/Group 48096931.png";

const Transfer = () => {
  return (
    <div className="transfer__section">
      <div className="transfer__section__first__card">
        <div className="transfer__section__first__card__image">
          <img src={image} alt="" />
        </div>
        <div className="transfer__section__first__card__text">
          <h3>MAKING TRANSFER <span>EASIER</span> FOR <span>AFRICANS</span></h3>
          <p>
            Every African knows at least one person that schools or buys
            products from another African country. And as Africans we realized
            the difficulty in sending or receiving another African currency,
            this is why we built MULA for you. MULA does your African
            transactions in simple steps that takes less than a minute at
            affordable rate.
          </p>
        </div>
      </div>
      <div className="transfer__section__second__card">
        <div className="transfer__section__second__card__image">
          <img src={image} alt="" />
        </div>
        <div className="transfer__section__second__card__text">
          <h3>EASILY SEND & RECEIVE MONEY QUICKLY</h3>
          <p>
            Whether you are sending/receiving money to/from another African
            country or you have travelled to another African country and need
            money in a new currency, Mula wallet serves you easily with no
            hassle.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Transfer;
